import React, { useEffect, useState } from "react";
import { web3Enable, web3Accounts } from "@polkadot/extension-dapp";
import { InjectedAccountWithMeta } from "@polkadot/extension-inject/types";
import { AddressAvatar } from "./AddressAvatar";

interface SubstrateAccountPickerProps {
  setAccount: (extensionAccount: InjectedAccountWithMeta) => void;
  currentStep: number;
}

const SubstrateAccountPicker: React.FC<SubstrateAccountPickerProps> = ({
  setAccount,
  currentStep,
}) => {
  const [accounts, setAccounts] = useState<InjectedAccountWithMeta[] | null>(
    null
  );
  const [selectedAccount, setSelectedAccount] = useState<string | null>(null);

  useEffect(() => {
    const getAccounts = async () => {
      await new Promise((r) => setTimeout(r, 100));
      await web3Enable("Acala EVM+ Account Bind");

      const allAccounts = await web3Accounts();
      setAccounts(allAccounts);
    };

    getAccounts();
  }, []);

  return (
    <div className="flex flex-col justify-center items-start min-w-[248px] p-3 bg-white border border-acala-blue-400 rounded-xl">
      {accounts
        ? accounts.length > 0
          ? accounts.map((account, index) => {
              return (
                <div
                  key={`account-${index}`}
                  className={`flex flex-row justify-start items-center ${
                    currentStep === 1 ? "cursor-pointer hover:bg-gray-200" : ""
                  } w-full rounded-lg ${
                    account.address === selectedAccount ? "bg-gray-200" : ""
                  }`}
                  onClick={() => {
                    if (currentStep !== 1) return;
                    setSelectedAccount(account.address);
                    setAccount(account);
                  }}
                >
                  <AddressAvatar
                    address={account.address}
                    size={32}
                    theme="polkadot"
                  />
                  <div>{account.meta.name}</div>
                </div>
              );
            })
          : "No accounts found"
        : "Loading..."}
    </div>
  );
};

export default SubstrateAccountPicker;
